import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Card } from 'shards-react';
import { EntypoCircleWithCross } from 'react-entypo-icons';
import { strings } from '../../localization';

const ScanInfoError = () => {
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center min-vh-100 bg-light"
    >
      <Row className="w-100 justify-content-center">
        <Col xs={10} sm={8} md={6} lg={4}>
          <Card className="p-4 text-center shadow rounded-3 bg-white">
            <div className="mb-3">
              <EntypoCircleWithCross size="64px" color="#ff4d4f" style={{fontSize: "64px"}} />
            </div>

            <h5 className="mb-2 text-danger">{strings.something_went_wrong_while_scan}</h5>
            <p className="text-muted mb-0">{strings.please_scan_again_msg}</p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ScanInfoError;